import axiosInstance from "./axios";

export const createSituation = async (data) => {
    const response = await axiosInstance.post("/situation/create", data);
    return response.data;
};

export const getSituations = async (params) => {
    const response = await axiosInstance.get("/situation/find", { params });
    return response.data;
};

export const updateSituation = async (id, data) => {
    const response = await axiosInstance.put(`/situation/update/${id}`, data);
    return response.data;
};

export const deleteSituation = async (id) => {
    const response = await axiosInstance.delete(`/situation/delete/${id}`);
    return response.data;
};

export const deleteMultipleSituations = async (ids) => {
    const response = await axiosInstance.post("/situation/delete-multiple", { ids });
    return response.data;
};